import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { API_PRIVATE_BASE } from "./utils/apiBase";
import "./styles/global.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const sentryTracingRateRaw = Number(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.2,
);
const sentryTracingRate = Number.isFinite(sentryTracingRateRaw)
  ? Math.min(1, Math.max(0, sentryTracingRateRaw))
  : 0.2;
const sentrySendDefaultPii =
  String(import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII || "false")
    .toLowerCase()
    .trim() === "true";
const tracePropagationTargets = ["localhost", API_PRIVATE_BASE];

Sentry.init({
  dsn: sentryDsn,
  sendDefaultPii: sentrySendDefaultPii,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: sentryTracingRate,
  tracePropagationTargets,
  environment: import.meta.env.MODE,
  enabled: Boolean(sentryDsn),
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
